import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AdminService } from '../../../../services/admin.service';
import { BusinessProcessService } from '../../../../services/business-process.service';
import { BusinessProcess } from '../../../../Models/businessProcess';
import { ReportsFilterComponent } from '../../../../common/reports-filter/reports-filter.component';
import {ReportsServiceService} from '../../../../services/reports-service';
import {GenericModalService} from '../../../../services/generic-modal.service';
import {BehaviorSubject} from 'rxjs';
import {InstanceHistoryResultComponent} from '../../../../common/reports-filter/instance-history-result/instance-history-result.component';
import {InstanceHistoryResultModalComponent} from './instance-history-result-modal/instance-history-result-modal.component';

@Component({
  selector: 'app-instance-history-stateLifeCyle',
  templateUrl: './instance-history-stateLifeCycle.component.html',
  styleUrls: ['./instance-history-stateLifeCycle.component.css']
})
export class InstanceHistoryStateLifeCycleComponent implements OnInit {

  availableBusinessProcess: BusinessProcess[];
  reportResult;
  availableStateLifeCycles: string[];
  resultError:string;
  submitted:boolean;
  filterCollapse$: BehaviorSubject<boolean>;
  lastFilter;


  @ViewChild('reportsFilterComponent', { static: false }) reportsFilterComponent: ReportsFilterComponent;

  constructor(
    private formBuilder: FormBuilder,
    private admService: AdminService,
    private bpService: BusinessProcessService,
    private reportService: ReportsServiceService,
    private modalService: GenericModalService
  ) { }

  ngOnInit() {
    this.submitted = false;
    this.loadBusinessProcessList();
    this.loadStateLifeCycles();
    this.filterCollapse$ = new BehaviorSubject(false)
  }


  loadBusinessProcessList() {
    this.resultError = '';
    this.bpService.getAllBusinessProcesses()
      .subscribe(
        result => {
          this.availableBusinessProcess = result;
        }, error1 => this.resultError = error1
      );
  }

  loadStateLifeCycles() {
    this.resultError = '';
    this.reportService.getStatesLifeCycles()
      .subscribe(
        result => {
          this.availableStateLifeCycles = result;
        }, error1 => {
          this.resultError = error1;
        }
      );
  }


  searchReport(filter){
    if (!filter.pageIndex){
      filter.pageIndex = 0;
    }

    this.submitted = false;
    this.reportResult = null;
    this.resultError = '';
    this.lastFilter = filter;
    this.reportService.getInstanceSummaryReport(filter)
      .subscribe(
        result => {
          this.submitted = true;
          this.reportResult = result;
          if (result){
            result.forEach(r =>{
              let bp = this.availableBusinessProcess.filter(bp => bp.businessProcessId == r.businessProcessId);
              if (bp && bp.length == 1){
                r.businessProcessName = bp[0].name;
              }
            })
            this.filterCollapse$.next(true);
          }
        },
          error => {
          this.resultError = error;
        }
      );
  }

  onResetFilter() {
    this.submitted = false;
    this.resultError = '';
  }

  showInstancesHistoryModal(item, lifeCycleValue, lifeCycleName) {
    let newFilter = this.lastFilter;
    newFilter.businessProcess = [item.businessProcessId];
    newFilter.states = [item.stateId];
    newFilter.stateLifeCycles = [lifeCycleValue];

    let inputDataModal = {
      filter: newFilter,
      availableBusinessProcess: this.availableBusinessProcess,
      stateName: item.stateName,
      lifeCycleName: lifeCycleName
    };

    const destComponent: any = InstanceHistoryResultModalComponent;
    this.modalService.showObjModal(destComponent, 'Histórico de Execução', inputDataModal, 'modal-xl');
  }


}
